export default __webpack_public_path__ + "static/media/tools-top.4e3823ca.png";